import { Chip } from '~/shared/ui'
import { getMatchStatusTone } from '../lib'

export function MatchStatusChip({ status }: { status: string }) {
  const tone = getMatchStatusTone(status)

  return (
    <Chip
      rounded
      size="xs"
      success={tone === 'success'}
      error={tone === 'failed'}
    >
      {status}
    </Chip>
  )
}
